import { AdminPortalB2BProducts } from '@stytch/react/b2b/adminPortal';
import {
  AuthFlowType,
  B2BProducts,
  B2BOAuthProviders,
} from '@stytch/vanilla-js';
import { AdminPortalStyleConfig } from '@stytch/vanilla-js/dist/adminPortal';

interface Role {
  role_id: string;
  description: string;
}

export const adminPortalConfig = {
  allowedAuthMethods: [
    AdminPortalB2BProducts.emailMagicLinks,
    AdminPortalB2BProducts.sso,
    AdminPortalB2BProducts.oauthGoogle,
  ],
  getRoleDescription: (role: Role) => {
    if (role.role_id === 'stytch_admin') {
      return 'Able to manage settings and members';
    } else if (role.role_id === 'stytch_member') {
      return 'Able to view settings and members, but cannot edit';
    } else {
      return role.description;
    }
  },
  getRoleDisplayName: (role: Role) => {
    if (role.role_id === 'stytch_admin') {
      return 'Admin';
    } else if (role.role_id === 'stytch_member') {
      return 'Member';
    } else {
      return role.role_id;
    }
  },
};

export const discoveryConfig = {
  products: [
    B2BProducts.sso,
    B2BProducts.oauth,
    B2BProducts.emailMagicLinks,
    B2BProducts.passwords,
  ],
  // TODO: Either auto extend the session or log out the user when the session expires and reduce this duration
  sessionOptions: { sessionDurationMinutes: 60 * 24 * 7 }, // 7 days
  emailMagicLinksOptions: {
    discoveryRedirectURL: `${window.location.origin}/authenticate`,
    loginRedirectURL: `${window.location.origin}/authenticate`,
    signupRedirectURL: `${window.location.origin}/authenticate`,
  },
  oauthOptions: {
    providers: [{ type: B2BOAuthProviders.Google }],
    discoveryRedirectURL: `${window.location.origin}/authenticate`,
    loginRedirectURL: `${window.location.origin}/authenticate`,
    signupRedirectURL: `${window.location.origin}/authenticate`,
  },
  ssoOptions: {
    loginRedirectURL: `${window.location.origin}/authenticate`,
    signupRedirectURL: `${window.location.origin}/authenticate`,
  },
  authFlowType: AuthFlowType.Discovery,
  directLoginForSingleMembership: {
    status: true,
    ignoreInvites: false,
    ignoreJitProvisioning: false,
  },
};

export const adminPortalStyles = {
  fontFamily: 'PP Neue Montreal',
  container: {
    width: '100%',
    padding: 0,
  },
} as Partial<AdminPortalStyleConfig>;

export const discoveryStyles = {
  fontFamily: 'PP Neue Montreal',
  container: { width: '100%' },
  buttons: {
    primary: {
      backgroundColor: '#dce64c', // Colors from the maximor.ai website
      textColor: '#164738',
    },
  },
  hideHeaderText: true,
};
